var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"MaterialSelector"},[_c('el-cascader',{style:({'width' : _vm.width}),attrs:{"options":_vm.materialTree,"show-all-levels":true,"props":{'value': 'id', 'label' : 'name'},"value":_vm.valueUse},on:{"input":_vm.change}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }